// Unpublished Work © 2021-2025 Deere & Company.

import React from 'react';
import {Redirect} from 'react-router-dom';
import {FullScreenCircularProgress} from '@deere/cap-it-ui.component-library';
import {useSelector} from 'react-redux';
import {CustomerRoutes} from '../../literals/customer-routes';

const getEntryRoute = (configuration) => {
    if (configuration.isStandalone) {
        return configuration.showExamples ? '/examples' : '/no-access';
    }

    return CustomerRoutes[configuration.routing.view];
};

export const EntryComponent = () => {
    const configuration = useSelector((state) => state.configuration);

    return configuration.isLoading ?
        <FullScreenCircularProgress loading={true}/> :
        <Redirect to={getEntryRoute(configuration)}/>;
};
